import React from 'react';

export default function NoAlerts () {
  return (
    <section className='no-alerts'>
      Please create a query using Quick Search or Query Builder and run a search. Then create an alert from the search results.
    </section>
  );
}
